import React, { Component } from "react";
import { Fade } from "react-awesome-reveal";
import Form from "./Form";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
class Contact extends Component {
  render() {
    let contentData = this.props.contentData;
    library.add(faEnvelope);
    library.add(faLocationDot);
    library.add(faPhone);
    const emailAddress = 'support@minervafinanceservices.com'
    return (
      <section className="contact-area" id="contact">
        <div className="container">
          <div className="row row-reverse">
            <div className="col-md-5 contact-info">
              <p className="contact-p">Contact Us</p>
              <p><FontAwesomeIcon className="icons" icon="fa-solid fa-location-dot" />Adress: District of Shumen Municipality Shumen
                Town of Shumen 1 Vasil Levski Str. office 9
                Shumen Bulgaria </p>
              <p><FontAwesomeIcon className="icons" icon="fa-solid fa-phone" />Phone Number: <a href={`tel:+359 877 736 616`}>+359 877 736 616</a></p>
              <p><FontAwesomeIcon className="icons" icon="fa-solid fa-envelope" />E-Mail: <a href={`mailto:${emailAddress}`}>{emailAddress}</a></p>

            </div>

            <div className="col-md-7">
              <Fade direction="Right" triggerOnce duration={800}>
                <div className="input_form">
                  <h4>{contentData.contacttitle}</h4>
                  <Form />
                  <div id="success">Your message succesfully sent!</div>
                  <div id="error">
                    Opps! There is something wrong. Please try again
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Contact;
